var locationHash;

var showAjaxLoading = function(){
    $("#loadingModal").show();
    $("#loadingModal img").css({'padding-top': $(window).height()/3});
};

var hideAjaxLoading = function(){
    $("#loadingModal").hide();
};

$(function () {
    Erdb.importErdbModule('Service/PasswordValidator');

    if ($.browser.msie) { $("body").addClass("msie").addClass("msie-"+$.browser.version.split('.0')[0]); }
    var redirect_after_restore = window.location.href.split('?redirect_after_restore=')[1];

    $("#login_pass_forgot").click(function(event, data){
        $($("#login_pass_forgot_tmpl").html()).dialog({
            height: "auto",
            width: 400,
            title: 'Восстановление логина и пароля',
            dialogClass: "lp_restore_dlg",
            modal: true,
            close: function( event, ui ) {
                $(this).remove();
                location.hash = '';
            },
            create: function( event, ui ) {
                if(typeof(data) != "undefined" && data.step == 2){
                    $(".login_pass_forgot_form .first-step").hide();
                    $(".login_pass_forgot_form .second-step").show();
                }
                $(".lp_restore_dlg #captcha_code").keyup(function(e){
                    if (e.keyCode == 13 && $(this).val() != "") {
                        $(".ui-dialog .login_pass_forgot_form form.step1").submit();
                    }
                });

                $(".lp_restore_dlg .button").button();
                $(".lp_restore_dlg #restore_phone").mask("(999)999-99-99");


                /***** RESTORE LOGIN AND PASS STEP 1 *****/
                $(".lp_restore_dlg #submit_restore_lp").click(function(){
                    $(".lp_restore_dlg form.step1").submit();
                });
                $(".lp_restore_dlg form.step1").validate({
                    ignoreTitle: true,
                    focusInvalid: false,
                    invalidHandler: function(form, validator) {
                        $(".lp_restore_dlg .work-res").html("&nbsp;");
                    },
                    submitHandler:function (form) {
                        $(".lp_restore_dlg .work-res").html("&nbsp;");
                        showAjaxLoading();
                        $.ajax({
                            type:"POST",
                            url:"php-local/api.php",
                            dataType:'json',
                            data:{
                                qryType:'forgot_login_pass',
                                surname: $(".lp_restore_dlg #restore_surname").val(),
                                name: $(".lp_restore_dlg #restore_name").val(),
                                middlename: $(".lp_restore_dlg #restore_middlename").val(),
                                partnumber: $(".lp_restore_dlg #restore_partnumber").val(),
                                phone: $(".lp_restore_dlg #restore_phone").val()
                            },
                            success: function(tr){
                                hideAjaxLoading();
                                if(tr.error != ''){
                                    $(".lp_restore_dlg .work-res").html("<span class='error-msg'>"+tr.error+"</span>").animateHighlight("#FAF000", 1000);
                                } else {
                                    location.hash = '#rl';

                                    /* save forgotten email for password validation */
                                    $(".lp_restore_dlg #restore_login_2").val(tr.email);
                                    $(".lp_restore_dlg .work-res-before").html(tr.msg2).animateHighlight("#FAF000", 1000);
                                    $(".lp_restore_dlg .first-step").toggle('slide', { }, 500, function(){
                                        if(tr.error2 != ''){
                                            $(".lp_restore_dlg .work-res-before").html(tr.error2).animateHighlight("#FAF000", 1000);
                                            $(".lp_restore_dlg .second-step").hide();
                                        } else {
                                            $(".lp_restore_dlg .second-step").show("slide", { direction: "right" }, 300);
                                        }
                                    });
                                }
                            },
							error: function(err){
								console.log(err);
							}
                        });
                    }
                });

                /***** RESTORE LOGIN AND PASS STEP 2 *****/
                $(".lp_restore_dlg #submit_restore_lp_2").click(function(){
                    $(".lp_restore_dlg form.step2").submit();
                });
                $(".lp_restore_dlg form.step2").validate({
                    ignoreTitle: true,
                    focusInvalid: false,
                    invalidHandler: function(form, validator) {
                        $(".lp_restore_dlg .work-res").html("&nbsp;");
                    },
                    submitHandler:function (form) {
                        $(".lp_restore_dlg .work-res").html("&nbsp;");
                        showAjaxLoading();
                        $.ajax({
                            type:"POST",
                            url:"php-local/api.php",
                            dataType:'json',
                            data:{qryType:'check_pin', pin: $(".lp_restore_dlg #restore_pin_2").val()},
                            success: function(tr){
                                hideAjaxLoading();
                                if(tr.error != ''){
                                    $(".lp_restore_dlg .work-res").html("<span class='error-msg'>"+tr.error+"</span>").animateHighlight("#FAF000", 1000);
                                } else {
                                    $(".lp_restore_dlg .work-res-before").html('');
                                    $(".lp_restore_dlg .second-step").toggle('slide', { }, 500, function(){
                                        $(".lp_restore_dlg .third-step").show("slide", { direction: "right" }, 300);
                                    });
                                }
                            },
							error: function(err){
								console.log(err);
							}
                        });
                    }
                });

                /***** RESTORE LOGIN AND PASS STEP 3 *****/
                $(".lp_restore_dlg #restore_pass_2")
                    .on('keyup focusin', (event) => {
                        showPasswordValidationTooltip(
                            '.lp_restore_dlg #restore_pass_2',
                            'position: fixed',
                            $(".lp_restore_dlg #restore_login_2").val()
                        );
                    })
                    .focusout((event) => $('.passwordValidationTooltip').remove());
                $(".lp_restore_dlg #submit_restore_lp_3").click(function(){
                    if (
                        isMemberPasswordValid({
                            login: $(".lp_restore_dlg #restore_login_2").val(),
                            password: $(".lp_restore_dlg #restore_pass_2").val()
                        })
                    ) {
                        $(".lp_restore_dlg form.step3").submit();
                    }
                });

                $('.lp_restore_dlg form.step3 .generate').click(function(){
                    $(this).blur();
                    $('#generatedPasswordError_1').html('');
                    $(".lp_restore_dlg #restore_pass_2").val('');
                    $(".lp_restore_dlg #restore_rep_pass_2").val('');

                    const generatedPassword = generateMemberPassword(10);
                    if (!generatedPassword.error) {
                        $(".lp_restore_dlg #restore_pass_2").val(generatedPassword.password);
                        $(".lp_restore_dlg #restore_rep_pass_2").val(generatedPassword.password);
                    } else {
                        $('#generatedPasswordError_1').html(generatedPassword.error);
                    }
                });

                $(".lp_restore_dlg form.step3").validate({
                    ignoreTitle: true,
                    focusInvalid: false,
                    rules: {
                        restore_rep_pass_2: {
                            equalTo: ".lp_restore_dlg #restore_pass_2"
                        }
                    },
                    invalidHandler: function(form, validator) {
                        $(".lp_restore_dlg .work-res").html("&nbsp;");
                        $(".lp_restore_dlg label.error").addClass("width-200");
                    },
                    submitHandler:function (form) {
                        $(".lp_restore_dlg .work-res").html("&nbsp;");
                        showAjaxLoading();
                        $.ajax({
                            type:"POST",
                            url:"php-local/api.php",
                            dataType:'json',
                            data:{
                                qryType:'update_pass',
                                pin: $(".lp_restore_dlg #restore_pin_2").val(),
                                pass: $(".lp_restore_dlg #restore_pass_2").val(),
                                login: $(".lp_restore_dlg #restore_login_2").val()
                            },
                            success: function(tr){
                                hideAjaxLoading();
                                if(tr.error != ''){
                                    $(".lp_restore_dlg .work-res").html("<span class='error-msg'>"+tr.error+"</span>").animateHighlight("#FAF000", 1000);
                                } else {
                                    $(".lp_restore_dlg #submit_restore_lp_3").hide();
                                    $(".lp_restore_dlg .third-step input").prop('disabled', true);
                                    $(".lp_restore_dlg .work-res").html("<span class='success-msg'>"+tr.msg+"</span>").animateHighlight("#FAF000", 1000);
                                    if (redirect_after_restore) {
                                        $('.lp_restore_dlg .work-res .success-msg').append('<br><a style="font-size:12px;" href="'+redirect_after_restore+'">Вернуться на страницу авторизации</a>')
                                    }
                                }
                            },
							error: function(err){
								console.log(err);
							}
                        });
                    }
                });
            }
        });
    });

    $("#pass_forgot").click(function(event, data){
        $($("#pass_forgot_tmpl").html()).dialog({
            height: "auto",
            width: 350,
            title: 'Восстановление пароля',
            dialogClass: "pass_restore_dlg",
            modal: true,
            close: function( event, ui ) {
                $(this).remove();
                location.hash = '';
            },
            create: function( event, ui ) {
                if(typeof(data) != "undefined" && data.step == 2){
                    $(".pass_forgot_form .first-step").hide();
                    $(".pass_forgot_form .second-step").show();
                }
                $.tipTipMy('.pass_restore_dlg #restore_login_1','Логин парт-почты');
                $.tipTipMy('.pass_restore_dlg #captcha_code','Введите код с картинки');
                $(".pass_restore_dlg #captcha_code").keyup(function(e){
                    if (e.keyCode == 13 && $(this).val() != "") {
                        $(".ui-dialog .pass_forgot_form form.step1").submit();
                    }
                });

                $(".pass_restore_dlg .button").button();

                $(".pass_restore_dlg #captcha_reload").click(function(){
                    $(".pass_restore_dlg #captcha_code").val('');
                    $('.pass_restore_dlg #captcha').attr('src','../../php/securimage/securimage_show.php?' + Math.random());
                    return false
                });

                /***** RESTORE PASSWORD STEP 1 *****/
                $(".pass_restore_dlg #submit_restore_pass").click(function(){
                    $(".pass_restore_dlg form.step1").submit();
                });
                $(".pass_restore_dlg form.step1").validate({
                    ignoreTitle: true,
                    focusInvalid: false,
                    invalidHandler: function(form, validator) {
                        $(".pass_restore_dlg .work-res").html("&nbsp;");
                    },
                    submitHandler:function (form) {
                        $(".pass_restore_dlg .work-res").html("&nbsp;");
                        showAjaxLoading();
                        $.ajax({
                            type:"POST",
                            url:"php-local/api.php",
                            dataType:'json',
                            data:{qryType:'forgot_pass', partEmail: $(".pass_restore_dlg #restore_login_1").val(), captcha: $(".pass_restore_dlg #captcha_code").val()},
                            success: function(tr){
                                hideAjaxLoading();
                                if(tr.error != ''){
                                    $(".pass_restore_dlg .work-res").html("<span class='error-msg'>"+tr.error+"</span>").animateHighlight("#FAF000", 1000);
                                } else {
                                    location.hash = '#rp';

                                    $(".pass_restore_dlg .work-res-before").html(tr.msg2).animateHighlight("#FAF000", 1000);
                                    $(".pass_restore_dlg .first-step").toggle('slide', { }, 500, function(){
                                        if(tr.error2 != ''){
                                            $(".pass_restore_dlg .work-res").html("<span class='error-msg'>"+tr.error2+"</span>").animateHighlight("#FAF000", 1000);
                                            $(".pass_restore_dlg .second-step").hide();
                                        } else {
                                            $(".pass_restore_dlg .second-step").show("slide", { direction: "right" }, 300);
                                        }
                                    });
                                }
                                eval(tr.js);
                            }
                        });
                    }
                });

                /***** RESTORE PASSWORD STEP 2 *****/
                $(".pass_restore_dlg #submit_restore_pass_2").click(function(){
                    $(".pass_restore_dlg form.step2").submit();
                });
                $(".pass_restore_dlg form.step2").validate({
                    ignoreTitle: true,
                    focusInvalid: false,
                    invalidHandler: function(form, validator) {
                        $(".pass_restore_dlg .work-res").html("&nbsp;");
                    },
                    submitHandler:function (form) {
                        $(".pass_restore_dlg .work-res").html("&nbsp;");
                        showAjaxLoading();
                        $.ajax({
                            type:"POST",
                            url:"php-local/api.php",
                            dataType:'json',
                            data:{qryType:'check_pin', pin: $(".pass_restore_dlg #restore_pin_1").val()},
                            success: function(tr){
                                hideAjaxLoading();
                                if(tr.error != ''){
                                    $(".pass_restore_dlg .work-res").html("<span class='error-msg'>"+tr.error+"</span>").animateHighlight("#FAF000", 1000);
                                } else {
                                    $(".pass_restore_dlg .work-res-before").html('');
                                    $(".pass_restore_dlg .second-step").toggle('slide', { }, 500, function(){
                                        $(".pass_restore_dlg .third-step").show("slide", { direction: "right" }, 300);
                                    });
                                }
                            }
                        });
                    }
                });

                /***** RESTORE PASSWORD STEP 3 *****/
                $(".pass_restore_dlg #restore_pass_1")
                    .on('keyup focusin', (event) => {
                        showPasswordValidationTooltip(
                            '.pass_restore_dlg #restore_pass_1',
                            'position: fixed',
                            $(".pass_restore_dlg #restore_login_1").val()
                        );
                    })
                    .focusout((event) => $('.passwordValidationTooltip').remove());
                $(".pass_restore_dlg #submit_restore_pass_3").click(function(){
                    if (
                        isMemberPasswordValid({
                            login: $(".pass_restore_dlg #restore_login_1").val(),
                            password: $(".pass_restore_dlg #restore_pass_1").val()
                        })
                    ) {
                        $(".pass_restore_dlg form.step3").submit();
                    }
                });
                $('.pass_restore_dlg .third-step .generate').click(function(){
                    $(this).blur();
                    $('#generatedPasswordError_2').html('');
                    $(".pass_restore_dlg #restore_pass_1").val('');
                    $(".pass_restore_dlg #restore_rep_pass_1").val('');

                    const generatedPassword = generateMemberPassword(10);
                    if (!generatedPassword.error) {
                        $(".pass_restore_dlg #restore_pass_1").val(generatedPassword.password);
                        $(".pass_restore_dlg #restore_rep_pass_1").val(generatedPassword.password);
                    } else {
                        $('#generatedPasswordError_2').html(generatedPassword.error);
                    }
                });
                $(".pass_restore_dlg form.step3").validate({
                    ignoreTitle: true,
                    focusInvalid: false,
                    rules: {
                        restore_rep_pass_1: {
                            equalTo: ".pass_restore_dlg #restore_pass_1"
                        }
                    },
                    invalidHandler: function(form, validator) {
                        $(".pass_restore_dlg .work-res").html("&nbsp;");
                        $(".pass_restore_dlg label.error").addClass("width-200");
                    },
                    submitHandler:function (form) {
                        $(".pass_restore_dlg .work-res").html("&nbsp;");
                        showAjaxLoading();
                        $.ajax({
                            type:"POST",
                            url:"php-local/api.php",
                            dataType:'json',
                            data:{
                                qryType:'update_pass',
                                pin: $(".pass_restore_dlg #restore_pin_1").val(),
                                pass: $(".pass_restore_dlg #restore_pass_1").val(),
                                login: $(".pass_restore_dlg #restore_login_1").val()
                            },
                            success: function(tr){
                                hideAjaxLoading();
                                if(tr.error != ''){
                                    $(".pass_restore_dlg .work-res").html("<span class='error-msg'>"+tr.error+"</span>").animateHighlight("#FAF000", 1000);
                                } else {
                                    $('input.generate').detach();
                                    $('a.continue').show();
                                    $(".pass_restore_dlg #submit_restore_pass_3").hide();
                                    $(".lp_restore_dlg .third-step input:not(.continue)").prop('disabled', true);
                                    $(".pass_restore_dlg .work-res").html("<span class='success-msg'>"+tr.msg+"</span>").animateHighlight("#FAF000", 1000);
                                    if (redirect_after_restore) {
                                        $('.pass_restore_dlg .work-res .success-msg').append('<br><a style="font-size:12px;" href="'+redirect_after_restore+'">Вернуться на страницу авторизации</a>')
                                    }
                                }
                            }
                        });
                    }
                });

            }
        });
    });

    const urlParams = new URLSearchParams(window.location.search);
    const login = urlParams.get('login');

    if (login) {
        $('#pass_forgot').trigger('click', [{ step : 1 }]);
        $('div.pass_restore_dlg #restore_login_1').val(login);
    }

    if(location.hash != '') {
        if(location.hash == "#rp" && $('#pass_forgot').length > 0){
            $('#pass_forgot').trigger('click', [{ step : 2 }]);
        }
        if(location.hash == "#rl" && $('#login_pass_forgot').length > 0){
            $('#login_pass_forgot').trigger('click', [{ step : 2 }]);
        }
    }
});

$.tipTipMy = function(selector, hintMsg){
    $(selector).tipTip({
        maxWidth:"auto",
        defaultPosition:"right",
        delay:0,
        content:hintMsg
    });
};

$.inputHints = function(selector, diffVal) {
    $(selector).val(diffVal);
    $.tipTipMy(selector,diffVal.split(':')[0]);
    $(selector).focusin(function () {
        $(this).removeClass('grey');
        if ($(this).val() == diffVal) {
            $(this).val('');
        }
    });

    $(selector).focusout(function () {
        var _this = this,
            timeout = $(this).hasClass('hasDatepicker') ? 300 : 1;  //datepicker hack

        setTimeout(function(){
            if ($(_this).val() == '' && !$("#ui-datepicker-div").is(":visible")) {
                $(_this).val(diffVal);
                $(_this).addClass('grey');
            }
        }, timeout);
    });
};

$.fn.animateHighlight = function(highlightColor, duration) {
    var highlightBg = highlightColor || "#FFFF9C";
    var animateMs = duration || 1500;
    var originalBg = this.css("backgroundColor");
    var originalPos = this.css("text-align");
    this.stop().css("background-color", highlightBg).animate({backgroundColor: originalBg}, animateMs, function(){$(this).removeAttr("style"); $(this).css({"text-align": originalPos})});
};

const isMemberPasswordValid = ({login, password = ''}) => {
    try {
        const passwordValidator = new Erdb.Service.PasswordValidator();
        passwordValidator.runMemberPasswordValidation({email: login, password});
        if (passwordValidator.isMemberPasswordValid) {
            return true;
        }
        else {
            $(".pass_restore_dlg .work-res, .lp_restore_dlg .work-res").html("<span class='error-msg'>"+passwordValidator.passwordValidationErrorMessage+"</span>").animateHighlight("#FAF000", 1000);
            return false;
        }
    }
    catch(err) {
        console.log(err);
        $.create_popup_dialog(`<span class="error-msg">${err}</span>`, 'Ошибка');
    }
};